import { render, staticRenderFns } from "./CustomColorPicker.vue?vue&type=template&id=4675854a&scoped=true"
import script from "./CustomColorPicker.vue?vue&type=script&lang=js"
export * from "./CustomColorPicker.vue?vue&type=script&lang=js"
import style0 from "./CustomColorPicker.vue?vue&type=style&index=0&id=4675854a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675854a",
  null
  
)

export default component.exports